<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'DefaultViewSettings',

  data() {
    return {
      displayModal: false,
      processing: false
    }
  },

  props: {
    settings: {
      type: Object,
      required: true
    },
    currentState: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    open() {
      this.displayModal = true
    },

    close() {
      this.displayModal = false
    },

    save() {
      this.processing = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: 'store-default-profiles-view',
          config: { headers: { 'Content-Type': 'application/json' } },
          data: {
            schema: {
              change_restrict: true,
              columns: {
                ...this.currentState
              }
            }
          }
        })
      )
        .then(_ => {
          this.$store
            .dispatch(
              'fetchProjectConfig',
              this.$router.currentRoute.query.project_id
            )
            .then(data => {
              this.processing = false
              this.displayModal = false
              this.$message({
                message: this.$t('DefaultViewSettings_SaveDialog_Success'),
                type: 'success'
              })
            })
            .catch(error => {
              this.processing = false
              this.displayModal = false
              this.$message({
                message: error.message,
                type: 'error'
              })
            })
        })
        .catch(error => {
          this.processing = false
          this.displayModal = false
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<template>
  <div>
    <el-dialog
      @close="close"
      :title="$t('DefaultViewSettings_SaveDialog_Title')"
      :visible="displayModal"
      :modal-append-to-body="false"
      width="500px"
      center
    >
      <div class="center">
        <p>{{ $t('DefaultViewSettings_SaveDialog_Question') }}</p>
        <div v-if="settings.last_update">
          <p>
            {{ $t('DefaultViewSettings_SaveDialog_LastUpdate') }}:
            {{ settings.last_update }}
          </p>
          <p>
            {{ $t('DefaultViewSettings_SaveDialog_UpdatedBy') }}:
            {{ settings.updated_by }}
          </p>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          plain
          @click="close"
          :disabled="processing"
        >
          {{ $t('DefaultViewSettings_SaveDialog_Button_Cancel') }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="save"
          :loading="processing"
          :disabled="processing"
        >
          {{ $t('DefaultViewSettings_SaveDialog_Button_Confirm') }}
        </el-button>
      </span>
    </el-dialog>
    <el-button type="primary" plain @click="open">
      {{ $t('UserProfiles_DefaultView_SaveSettings') }}
    </el-button>
  </div>
</template>

<style scoped>
.center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/DefaultViewSettings.vue